const DocumentTitleFormatter = title => {
  return `${title} | RelyMD Provider`;
};

export default DocumentTitleFormatter;
